import { Link } from "react-router-dom";
import { ShoppingBasket, Flame } from "lucide-react";
import { gbp } from "@/data/shop";
import { productPath } from "@/lib/seo";
import { srcSet } from "@/lib/api";
import { useFocus } from "@/lib/focus";

const BADGE = {
  New: "bg-[#2BB673] text-white",
  "Open Box": "bg-[#2F80ED] text-white",
  "Like New": "bg-[#7B5CF0] text-white",
  Good: "bg-[#FF7A2F] text-white",
  Fair: "bg-[#D63C7A] text-white",
  "For Parts": "bg-[#6B7280] text-white",
};

export const ConditionBadge = ({ condition, testId, className = "" }) => (
  <span data-testid={testId} className={`text-[11px] font-bold px-2 py-0.5 rounded-full ${BADGE[condition]} ${className}`}>{condition}</span>
);

const CardImg = (props) => <img {...props} style={useFocus(props.src)} />;

export const ProductCard = ({ p, onAdd }) => (
  <article data-testid={`product-card-${p.id}`}
    className="group flex flex-col rounded-2xl overflow-hidden bg-white border-2 border-[#202A35]/10 hover:border-[#202A35] transition-[transform,border-color] duration-200 hover:-translate-y-1">
    <Link to={productPath(p)} data-testid={`product-link-${p.id}`} className="relative block aspect-[4/3] bg-[#F5F6F7] overflow-hidden">
      <CardImg src={p.img} srcSet={srcSet(p.img)} sizes="(min-width: 1024px) 240px, 50vw" width="400" height="300" alt={p.name} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
      <ConditionBadge condition={p.condition} testId={`product-condition-${p.id}`} className="absolute top-2 left-2" />
      {p.popular && (
        <span data-testid={`product-popular-${p.id}`} className="absolute top-2 right-2 inline-flex items-center gap-1 text-[11px] font-bold px-2 py-0.5 rounded-full bg-[#202A35] text-[#FFC21A]">
          <Flame size={11} /> Popular
        </span>
      )}
    </Link>
    <div className="flex flex-col flex-1 p-3">
      <div className="flex items-baseline gap-1.5 flex-wrap">
        <span data-testid={`product-price-${p.id}`} className="font-display text-xl font-bold text-[#202A35]">{gbp(p.price)}</span>
        {p.was && <span className="text-[11px] text-[#202A35]/55">was <span className="line-through">{gbp(p.was)}</span></span>}
      </div>
      <Link to={productPath(p)} className="mt-1 text-[13px] font-semibold leading-snug line-clamp-2 text-[#202A35] hover:underline">{p.name}</Link>
      <p className="mt-0.5 mb-3 text-[11px] text-[#202A35]/55">{p.note || p.category}{p.demo && <span data-testid={`demo-label-${p.id}`} className="ml-1 font-semibold text-[#8A5E00]">· Demo item</span>}</p>
      <button onClick={() => onAdd(p)} disabled={p.qty === 0} data-testid={`add-to-basket-${p.id}`}
        className="mt-auto h-9 w-full rounded-full text-[13px] font-bold inline-flex items-center justify-center gap-1.5 bg-[#FFD23F] text-[#202A35] hover:bg-[#202A35] hover:text-white transition-colors disabled:bg-[#F5F6F7] disabled:text-[#202A35]/45 disabled:cursor-not-allowed">
        {p.qty === 0 ? "Out of Stock" : <><ShoppingBasket size={15} /> Add to Basket</>}
      </button>
    </div>
  </article>
);
